import React, { useEffect, useState } from "react";
import KaComparison from "@/components/KaComparison";
import { Download, FileText, Loader2 } from "lucide-react";
import jsPDF from "jspdf";
import api from "@/lib/api";

export default function Templates() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/templates").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  const download = async (key, title) => {
    try {
      const { data: tpl } = await api.get(`/templates/${key}`);
      const doc = new jsPDF();
      doc.setFont("helvetica", "bold");
      doc.setFontSize(16);
      doc.text(tpl.title, 14, 20);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(11);
      const lines = doc.splitTextToSize(tpl.content, 180);
      doc.text(lines, 14, 32);
      doc.save(`${key}.pdf`);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10 animate-fade-in-up">
      <div className="flex items-center gap-3">
        <div className="w-12 h-12 bg-blue-700 text-white flex items-center justify-center rounded-sm">
          <FileText className="w-6 h-6 stroke-[1.5]" />
        </div>
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold">Bygglovsguide</div>
          <h1 className="text-3xl font-semibold tracking-tight" style={{ fontFamily: "Outfit" }}>Handlingsmallar</h1>
        </div>
      </div>
      <p className="mt-3 text-zinc-600 max-w-2xl">Ladda ner färdiga mallar för kontrollplan, ansökan, anmälan och grannemedgivande som PDF.</p>

      {loading ? (
        <div className="flex justify-center py-20"><Loader2 className="w-5 h-5 animate-spin text-zinc-500" /></div>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-4">
          {items.map((t) => (
            <div key={t.key} className="bg-white border border-zinc-200 rounded-sm p-5 flex flex-col">
              <FileText className="w-8 h-8 text-blue-700 stroke-[1.5]" />
              <h3 className="mt-4 font-medium text-lg" style={{ fontFamily: "Outfit" }}>{t.title}</h3>
              <p className="mt-1 text-sm text-zinc-600 leading-relaxed flex-1">{t.description}</p>
              <button
                onClick={() => download(t.key, t.title)}
                data-testid={`download-${t.key}`}
                className="mt-4 inline-flex items-center justify-center gap-2 bg-blue-700 hover:bg-blue-800 text-white px-4 py-2 rounded-sm text-sm font-medium"
              >
                <Download className="w-3.5 h-3.5" /> Ladda ner PDF
              </button>
            </div>
          ))}
        </div>
      )}

      <KaComparison hideTemplatesCta />
    </div>
  );
}
